import React from 'react';
import { styled } from '@compiled/react';
import Button from '@atlaskit/button';
import ShortcutIcon from '@atlaskit/icon/core/link-external';
import SectionMessage, { SectionMessageAction } from '@atlaskit/section-message';
import { token } from '@atlaskit/tokens';
import { expVal } from '@atlassian/jira-feature-experiments';
import { useIntl } from '@atlassian/jira-intl';
import {
	useAnalyticsEvents,
	fireUIAnalytics,
	ContextualAnalyticsData,
	BANNER,
	FireScreenAnalytics,
} from '@atlassian/jira-product-analytics-bridge';
import messages from './messages.tsx';

type Props = {
	portalLink: string;
};

export const ProformaBanner = ({ portalLink }: Props) => {
	const { formatMessage } = useIntl();
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const onOpenPortalLinkClick = () => {
		fireUIAnalytics(createAnalyticsEvent({}), 'gicProformaBannerOpenPortalButton clicked');
	};

	return (
		<ContextualAnalyticsData sourceName="gicProforma" sourceType={BANNER}>
			<BannerContainer data-testid="issue-create.ui.modal.create-form.proforma-banner.banner-container">
				<SectionMessage
					appearance="information"
					title={formatMessage(messages.title)}
					actions={[
						<SectionMessageAction key="openPortalLink">
							<Button
								appearance="link"
								href={portalLink}
								target="_blank"
								spacing="none"
								onClick={onOpenPortalLinkClick}
								onAuxClick={onOpenPortalLinkClick}
								iconAfter={
									<IconWrapper>
										<ShortcutIcon label={formatMessage(messages.newTabIconDescription)} />
									</IconWrapper>
								}
							>
								{formatMessage(messages.openPortal)}
							</Button>
						</SectionMessageAction>,
					]}
				>
					{formatMessage(
						expVal('issue-terminology-refresh-m2-replace', 'isEnabled', false)
							? messages.textIssueTermRefresh
							: messages.text,
					)}
				</SectionMessage>
			</BannerContainer>
			<FireScreenAnalytics />
		</ContextualAnalyticsData>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const IconWrapper = styled.span({
	marginLeft: token('space.050'),
	fontWeight: token('font.weight.regular'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const BannerContainer = styled.div({
	marginTop: token('space.300'),
});
